module.exports = __webpack_public_path__ + "img/tab_location.3dc52cf7.svg";